export enum VIEWS {
    primary = 'primary',
    secondary = 'secondary'
}

export enum COLORS {
    success = 'success',
    negative = 'negative'
}

export enum SIZES {
    large = 'large',
    medium = 'medium',
    small = 'small'
}
